// extracted by mini-css-extract-plugin
export var addressFields = "_jk-0";
export var animationContainer = "_jk-1";
export var footer = "_jk-2";
export var lineItems = "_jk-3";
export var modalContent = "_jk-4";
export var orderName = "_jk-5";
export var strong = "_jk-6";
export var warning = "_jk-7";